import { render, staticRenderFns } from "./HistoryOfIllness.vue?vue&type=template&id=c4225504&"
import script from "./HistoryOfIllness.vue?vue&type=script&lang=js&"
export * from "./HistoryOfIllness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports